var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-file-toolbar-menu',{attrs:{"content":_vm.my_menu_one}})
}
var staticRenderFns = []

export { render, staticRenderFns }